import { tabs } from './tabs';
import {
    MAX_EMAIL_LENGTH, MAX_NAME_LENGTH, MAX_DONATION_VALUE, MAX_COMPANY_NAME_LENGTH,
    MAX_DONATION_MESSAGE_OF_SUPPORT_LENGTH
} from '../../../constants/index';

export const paths = {
    SALUTATION: 'customer.salutation',
    FIRST_NAME: 'customer.firstName',
    LAST_NAME: 'customer.lastName',
    EMAIL: 'customer.email',
    ACTIVE_PAGE: 'activePage',
    LEAVE_SUPPORT_MESSAGE: 'leaveSupportMessage',
    SELECTED_DISPLAY_NAME_OPTION: 'selectedDisplayNameOption',
    DISPLAY_NAME: 'displayName',
    MESSAGE: 'message',
    BUSINESS_NAME: 'customer.businessName',
    ANONYMOUS: 'customer.anonymous',
    RECEIVE_NEWS_LETTER: 'customer.newsletter',
    FORMBUILDER_ANSWERS: 'formbuilderAnswers',
    IS_DETAILS_TAB_VALID: `tabsValidation.${tabs.DETAILS}`,
    IS_AMOUNT_TAB_VALID: `tabsValidation.${tabs.AMOUNT}`,
    IS_USER_AGREED_TERMS: 'isUserAgreedTerms',
    IS_BEHALF_OF_COMPANY: 'customer.isBehalfOfCompany',
    ADDRESS: 'address',
    PHONE_NUMBER: 'phoneNumber'
}

// TODO: make typescript class 
export const fieldsValidation = {
    EMAIL: {
        required: true,
        email: true,
        maxLengthValidation: true,
        maxLength: MAX_EMAIL_LENGTH,
        path: paths.EMAIL
    },
    FIRST_NAME: {
        required: true,
        maxLengthValidation: true,
        maxLength: MAX_NAME_LENGTH,
        path: paths.FIRST_NAME
    },
    LAST_NAME: {
        required: true,
        maxLengthValidation: true,
        maxLength: MAX_NAME_LENGTH,
        path: paths.LAST_NAME
    },
    BUSINESS_NAME: {
        maxLengthValidation: true,
        maxLength: MAX_COMPANY_NAME_LENGTH,
        path: paths.BUSINESS_NAME
    },
    MESSAGE: {
        maxLengthValidation: true,
        maxLength: MAX_DONATION_MESSAGE_OF_SUPPORT_LENGTH,
        path: paths.MESSAGE
    },
    FORMBUILDER_ANSWERS: {
        formBuilderAnswers: true,
        path: paths.FORMBUILDER_ANSWERS
    }
}

export const recurringFieldsValidation = {
    EMAIL: {
        required: true,
        email: true,
        maxLengthValidation: true,
        maxLength: MAX_EMAIL_LENGTH,
        path: paths.EMAIL
    },
    FIRST_NAME: {
        required: true,
        maxLengthValidation: true,
        maxLength: MAX_NAME_LENGTH,
        path: paths.FIRST_NAME
    },
    LAST_NAME: {
        required: true,
        maxLengthValidation: true,
        maxLength: MAX_NAME_LENGTH,
        path: paths.LAST_NAME
    }
}

export const recurringCustomFieldsValidation = {
    SALUTATION: {
        path: paths.SALUTATION
    },
    ADDRESS: {
        formbuilderAddress: true,
        path: paths.ADDRESS
    },
    PHONE_NUMBER: {
        phone: true,
        path: paths.PHONE_NUMBER
    }
}

export const pageTypes = {
    CAMPAIGN: 1,
    FUNDRAISER: 2,
    TEAM: 3,
    COLLECTION: 4
}

export const AMOUNT_VALIDATION = {
    amount: true,
    required: true,
    maxValue: MAX_DONATION_VALUE
}